<template>
  <AuthWrap :title="$t('register.signIn')" :text="$t('register.enterOwnData')">
    <form @submit.prevent="handleCorrectInput" class="col">
      <PrimarySelect
        iconPath="M32.5827 17.2113C32.5827 8.60483 25.6058 1.62793 16.9993 1.62793C8.39291 1.62793 1.41602 8.60483 1.41602 17.2113C1.41602 25.8177 8.39291 32.7946 16.9993 32.7946C25.6058 32.7946 32.5827 25.8177 32.5827 17.2113ZM28.8394 12.4718C27.5454 9.24222 24.9684 6.66517 21.7388 5.37121C22.4965 6.83399 23.0909 8.65777 23.4916 10.719C25.5528 11.1197 27.3766 11.7141 28.8394 12.4718ZM10.5071 10.719C10.9078 8.65777 11.5022 6.83399 12.2599 5.37121C9.03031 6.66517 6.45325 9.24222 5.1593 12.4718C6.62208 11.7141 8.44585 11.1197 10.5071 10.719ZM4.24935 17.2113C4.24935 15.9373 6.55665 14.555 10.0782 13.7237C9.97133 14.8466 9.91602 16.0142 9.91602 17.2113C9.91602 18.4083 9.97133 19.5759 10.0782 20.6988C6.55665 19.8675 4.24935 18.4852 4.24935 17.2113ZM5.1593 21.9507C6.62208 22.7084 8.44585 23.3028 10.5071 23.7035C10.9078 25.7648 11.5022 27.5885 12.2599 29.0513C9.03031 27.7574 6.45325 25.1803 5.1593 21.9507ZM23.4916 23.7035C23.0909 25.7648 22.4965 27.5885 21.7388 29.0513C24.9684 27.7574 27.5454 25.1803 28.8394 21.9507C27.3766 22.7084 25.5528 23.3028 23.4916 23.7035ZM24.0827 17.2113C24.0827 18.4083 24.0274 19.5759 23.9205 20.6988C27.442 19.8675 29.7493 18.4852 29.7493 17.2113C29.7493 15.9373 27.442 14.555 23.9205 13.7237C24.0274 14.8466 24.0827 16.0142 24.0827 17.2113ZM12.7493 17.2113C12.7493 15.8084 12.8373 14.4625 12.9939 13.2058C14.2506 13.0492 15.5965 12.9613 16.9993 12.9613C18.4022 12.9613 19.7481 13.0492 21.0048 13.2058C21.1614 14.4625 21.2493 15.8084 21.2493 17.2113C21.2493 18.6141 21.1614 19.96 21.0048 21.2167C19.7481 21.3733 18.4022 21.4613 16.9993 21.4613C15.5965 21.4613 14.2506 21.3733 12.9939 21.2167C12.8373 19.96 12.7493 18.6141 12.7493 17.2113ZM13.5118 24.1324C14.3431 27.654 15.7254 29.9613 16.9993 29.9613C18.2733 29.9613 19.6556 27.654 20.4869 24.1324C19.364 24.2393 18.1964 24.2946 16.9993 24.2946C15.8023 24.2946 14.6347 24.2393 13.5118 24.1324ZM16.9993 4.46126C15.7254 4.46126 14.3431 6.76856 13.5118 10.2901C14.6347 10.1832 15.8023 10.1279 16.9993 10.1279C18.1964 10.1279 19.364 10.1832 20.4869 10.2901C19.6556 6.76856 18.2733 4.46126 16.9993 4.46126Z"
        class="input"
        :success="success.country"
        :errText="error.country ? ' ' : ''"
      >
        <select
          @blur="success.country = country != ''"
          v-model="country"
          name="country"
          id="country"
        >
          <option disabled value="">{{ $t("register.country") }}</option>
          <option
            v-for="item in choicesLabel?.country"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </option>
        </select>
      </PrimarySelect>
      <PrimaryInput
        iconPath="M18.5536 26.0725L17.0007 27.4285L15.4477 26.0725C9.90092 21.2291 7.08398 16.9432 7.08398 12.9606C7.08398 7.32428 11.4806 3.04395 17.0007 3.04395C22.5207 3.04395 26.9173 7.32428 26.9173 12.9606C26.9173 16.9432 24.1004 21.2291 18.5536 26.0725ZM8.05518 21.1821C8.63685 21.9785 9.2848 22.7885 9.99874 23.6125C7.36059 24.2067 5.66732 25.05 5.66732 25.7106C5.66732 26.8538 10.7378 28.5439 17.0007 28.5439C23.2635 28.5439 28.334 26.8538 28.334 25.7106C28.334 25.05 26.6407 24.2067 24.0026 23.6125C24.7165 22.7885 25.3645 21.9785 25.9461 21.1821C29.1319 22.1488 31.1673 23.6995 31.1673 25.7106C31.1673 29.2618 24.821 31.3773 17.0007 31.3773C9.18027 31.3773 2.83398 29.2618 2.83398 25.7106C2.83398 23.6995 4.86936 22.1488 8.05518 21.1821ZM17.0007 5.87728C20.9726 5.87728 24.084 8.90634 24.084 12.9606C24.084 15.8605 21.7786 19.429 17.0007 23.665C12.2227 19.429 9.91732 15.8605 9.91732 12.9606C9.91732 8.90634 13.0287 5.87728 17.0007 5.87728ZM17.0007 8.71061C19.3479 8.71061 21.2507 10.6134 21.2507 12.9606C21.2507 15.3078 19.3479 17.2106 17.0007 17.2106C14.6534 17.2106 12.7507 15.3078 12.7507 12.9606C12.7507 10.6134 14.6534 8.71061 17.0007 8.71061ZM15.584 12.9606C15.584 12.1782 16.2182 11.5439 17.0007 11.5439C17.7831 11.5439 18.4173 12.1782 18.4173 12.9606C18.4173 13.743 17.7831 14.3773 17.0007 14.3773C16.2182 14.3773 15.584 13.743 15.584 12.9606Z"
        :errText="error.city ? ' ' : ''"
        :success="success.city"
        class="input"
      >
        <input
          @blur="city = city.trim(); success.city = city.trim().length != 0; error.city = city.trim().length == 0"
          v-model="city"
          @focus="error.city = false"
          @input="inputCity(city)"
          type="text"
          class="border-input"
          :placeholder="$t('register.city')"
        />
      </PrimaryInput>
      <PrimaryInput
        iconPath="M8.50065 31.378C10.3511 31.378 11.9254 30.1954 12.5088 28.5447H24.7923C28.3131 28.5447 31.1673 25.6905 31.1673 22.1697C31.1673 18.6489 28.3131 15.7947 24.7923 15.7947H9.20898C7.25298 15.7947 5.66732 14.209 5.66732 12.253C5.66732 10.297 7.25298 8.71137 9.20898 8.71137H13.5805L11.7489 10.543L13.7524 12.5464L19.0041 7.2947L13.7524 2.04297L11.7489 4.04644L13.5805 5.87804H9.20898C5.68817 5.87804 2.83398 8.73222 2.83398 12.253C2.83398 15.7739 5.68817 18.628 9.20898 18.628H24.7923C26.7483 18.628 28.334 20.2137 28.334 22.1697C28.334 24.1257 26.7483 25.7114 24.7923 25.7114H12.5088C11.9254 24.0607 10.3511 22.878 8.50065 22.878C6.15344 22.878 4.25065 24.7808 4.25065 27.128C4.25065 29.4752 6.15344 31.378 8.50065 31.378ZM7.08398 27.128C7.08398 26.3456 7.71825 25.7114 8.50065 25.7114C9.28306 25.7114 9.91732 26.3456 9.91732 27.128C9.91732 27.9104 9.28306 28.5447 8.50065 28.5447C7.71825 28.5447 7.08398 27.9104 7.08398 27.128ZM25.5007 3.0447C27.8479 3.0447 29.7507 4.94749 29.7507 7.2947C29.7507 9.64191 27.8479 11.5447 25.5007 11.5447C23.1534 11.5447 21.2507 9.64191 21.2507 7.2947C21.2507 4.94749 23.1534 3.0447 25.5007 3.0447ZM24.084 7.2947C24.084 6.5123 24.7182 5.87804 25.5007 5.87804C26.2831 5.87804 26.9173 6.5123 26.9173 7.2947C26.9173 8.07711 26.2831 8.71137 25.5007 8.71137C24.7182 8.71137 24.084 8.07711 24.084 7.2947Z"
        :errText="error.address1 ? ' ' : ''"
        :success="success.address1"
        class="input"
      >
        <input
          v-model="address1"
          @blur="address1 = address1.trim(); success.address1 = address1.length != 0; error.address1 = address1.length == 0"
          @input="inputAddress1(address1)"
          @focus="error.address1 = false"
          type="text"
          class="border-input"
          :placeholder="$t('register.address1')"
        />
      </PrimaryInput>
      <PrimaryInput
        iconPath="M8.34163 14.3773L16.8435 5.8754L25.3454 14.3773H25.3435V28.5439H8.34354V14.3773H8.34163ZM5.5102 17.2087L3.41805 19.3009L1.41602 17.2988L14.8417 3.87311C15.9473 2.76756 17.7397 2.76756 18.8453 3.87311L32.271 17.2988L30.269 19.3009L28.1769 17.2087V28.5439C28.1769 30.1088 26.9083 31.3773 25.3435 31.3773H8.34354C6.77873 31.3773 5.5102 30.1088 5.5102 28.5439V17.2087Z"
        :errText="error.address2 ? ' ' : ''"
        class="input"
        :success="success.address2"
      >
        <input
          v-model="address2"
          @input="inputAddress2(address2)"
          @focus="error.address2 = false"
          @blur="address2 = address2.trim(); success.address2 = address2.length != 0; error.address2 = address2.length == 0"
          type="text"
          class="border-input"
          :placeholder="$t('register.address2')"
        />
      </PrimaryInput>
      <PrimaryInput
        iconPath="M4.24935 4.46094H29.7493C31.3142 4.46094 32.5827 5.72946 32.5827 7.29427V27.1276C32.5827 28.6924 31.3142 29.9609 29.7493 29.9609H4.24935C2.68454 29.9609 1.41602 28.6924 1.41602 27.1276V7.29427C1.41602 5.72946 2.68454 4.46094 4.24935 4.46094ZM4.24935 13.8366V27.1276H29.7493V13.8372L16.9993 20.2122L4.24935 13.8366ZM4.24935 10.6688L16.9994 17.0444L29.7493 10.6694V7.29427H4.24935V10.6688Z"
        :errText="error.postal_index ? ' ' : ''"
        class="input"
        :success="success.postal_index"
      >
        <input
          v-model="postal_index"
          @input="inputNumber(postal_index)"
          @focus="error.postal_index = false"
          maxlength="6"
          @blur="success.postal_index = postal_index.length >= 5 && postal_index.length <= 6 && !isNaN(postal_index); error.postal_index = postal_index.length < 5 || postal_index.length > 6 || isNaN(postal_index)"
          type="text"
          pattern="[0-9]{5,6}"
          class="border-input"
          :placeholder="$t('register.postal_index')"
        />
      </PrimaryInput>
      <PrimaryButton
        style="margin-bottom: 1.875rem"
        :title="$t('buttons.next')"
      />
      <PrimaryButton :title="$t('register.prev')" isOutlined />
    </form>
  </AuthWrap>
</template>

<script>
import { useStore } from "vuex";
import { computed, reactive, toRefs } from "vue";
import AuthWrap from "../AuthWrap.vue";
import PrimarySelect from "../PrimarySelect.vue";
import PrimaryInput from "../PrimaryInput.vue";
import PrimaryButton from "../PrimaryButton.vue";
export default {
  components: { AuthWrap, PrimarySelect, PrimaryInput, PrimaryButton },
  setup(_, { emit }) {
    const store = useStore();
    const info = reactive({
      country: "",
      city: "",
      address1: "",
      address2: "",
      postal_index: "",
    });
    const error = reactive({
      country: false,
      city: false,
      address1: false,
      address2: false,
      postal_index: false,
    });

    const success = reactive({
      country: false,
      city: false,
      address1: false,
      address2: false,
      postal_index: false,
    });

    const inputCity = (val) => {
      info.city = val.replace(/[^a-zA-Z0-9\s/,._()-{}&!#$%\\]+/giu, "");
    };
    const inputAddress1 = (val) => {
      info.address1 = val.replace(/[^a-zA-Z0-9\s/,._()-{}&!#$%\\]+/giu, "");
    };
    const inputAddress2 = (val) => {
      info.address2 = val.replace(/[^a-zA-Z0-9\s/,._()-{}&!#$%\\]+/giu, "");
    };

    const inputNumber = (val) => {
      info.postal_index = val.toString().substring(0, 6);
    };

    const handleCorrectInput = () => {
      for (const el in info) {
        if (info[el]) {
          error[el] = false;
        } else {
          error[el] = true;
        }
      }
      if (info.postal_index.toString().length == 6 || info.postal_index.toString().length == 5) {
        success.postal_index = true;
        error.postal_index = false;
      } else {
        error.postal_index = true;
        success.postal_index = false;
      }
      if (Object.values(error).indexOf(true) == -1) {
        store.commit("register/setUser", { ...info });
        emit("next");
      }
    };

    return {
      handleCorrectInput,
      choicesLabel: computed(() => store.getters["register/getchoicesLabel"]),
      ...toRefs(info),
      success,
      error,
      inputCity,
      inputAddress1,
      inputAddress2,
      inputNumber,
    };
  },
};
</script>

<style lang="scss" scoped>
label {
  font-weight: 500;
  color: var(--gray-font-color);
  margin-bottom: 1em;
  line-height: 1;
  display: block;
}
.border-input.select {
  width: calc(100% + 1em);
}
.col {
  width: 100%;
  &__item {
    margin-top: 1.5em;
    min-width: 340px;
    width: 60%;
    input {
      width: 100%;
    }
  }
}
@media screen and (max-width: 576px) {
  .border-input.select {
    // width: 80% !important;
  }
  .col {
    &__item {
      min-width: auto;
      .border-input {
        // width: auto !important;
        width: 100%;
      }
    }
  }
}
</style>
